const WarningBlock = ({ date, title, url }) => {
    return <div>
        <p>{date}</p>
        <a>{title}</a>
    </div>
}

export default WarningBlock;